import { FilterChipsInput } from './FilterChips/FilterChipsInput';
import { FilterMenu } from './FilterMenu';
import { useMenuAnchor } from './UseMenuAnchor';

export type Filter = {
  name: string;
  menu: JSX.Element;
  isFiltering?: boolean;
  isLoading?: boolean;
};

export type Filters = {
  [key: string]: Filter;
};

export type ChipType = {
  key: string;
  value: string | JSX.Element;
  onDelete: () => void;
};

export type FilterMenuProps = {
  filters: Filters;
  chips: ChipType[];
  onClearAllFilters: () => void;
};

export const FiltersMenu = ({ filters, chips, onClearAllFilters }: FilterMenuProps) => {
  const { anchorEl, handleClick, handleClose, isOpen } = useMenuAnchor();

  return (
    <>
      <FilterChipsInput
        chips={chips}
        onClearAllFilters={onClearAllFilters}
        onMenuClick={handleClick}
        variant="secondary"
      />
      <FilterMenu
        filters={filters}
        id="basic-menu"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        sx={{
          minWidth: '300px'
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      />
    </>
  );
};
